export const works = [
  {
    href: 'https://christiantesauro.com/',
    image: '/images/carousel/christian.jpg',
    imageAlt: 'Christian Tesauro Portfolio',
    badges: [
      { type: 'developer', label: 'Developer' },
      { type: 'designer', label: 'Designer' }
    ],
    title: "Christian Tesauro's Portfolio",
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: 'https://www.youtube.com/watch?v=qUGPKGfUWwg',
    image: '/images/carousel/kaijudores.png',
    imageAlt: 'Kaijudores',
    badges: [
      { type: 'game', label: 'Game' },
      { type: 'developer', label: 'Developer' }
    ],
    title: 'Kaijudores: Rock, Paper, Atomic Breath!',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: '#',
    image: 'https://placehold.co/500x400',
    imageAlt: 'Card Image',
    badges: [{ type: 'game', label: 'Game' }],
    title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: '#',
    image: 'https://placehold.co/500x400',
    imageAlt: 'Card Image',
    badges: [{ type: 'designer', label: 'Designer' }],
    title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: '#',
    image: 'https://placehold.co/500x400',
    imageAlt: 'Card Image',
    badges: [{ type: 'designer', label: 'Designer' }],
    title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: '#',
    image: 'https://placehold.co/500x400',
    imageAlt: 'Card Image',
    badges: [{ type: 'designer', label: 'Designer' }],
    title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: '#',
    image: 'https://placehold.co/500x400',
    imageAlt: 'Card Image',
    badges: [{ type: 'designer', label: 'Designer' }],
    title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  },
  {
    href: '#',
    image: 'https://placehold.co/500x400',
    imageAlt: 'Card Image',
    badges: [{ type: 'designer', label: 'Designer' }],
    title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
  }
]
